import { gettext } from '@eventbrite/i18n';
import React from 'react';

interface CalendarIconProps {
    className?: string;
    'aria-label'?: string;
}

export const CalendarIcon: React.FC<CalendarIconProps> = ({
    className,
    'aria-label': ariaLabel,
}) => (
    <svg
        className={className}
        aria-label={ariaLabel || gettext('Calendar').toString()}
        role="img"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M6.00065 6.4987C6.00065 7.05098 5.55294 7.4987 5.00065 7.4987C4.44837 7.4987 4.00065 7.05098 4.00065 6.4987C4.00065 5.94641 4.44837 5.4987 5.00065 5.4987C5.55294 5.4987 6.00065 5.94641 6.00065 6.4987Z" />
        <path d="M8.00065 7.4987C8.55294 7.4987 9.00065 7.05098 9.00065 6.4987C9.00065 5.94641 8.55294 5.4987 8.00065 5.4987C7.44837 5.4987 7.00065 5.94641 7.00065 6.4987C7.00065 7.05098 7.44837 7.4987 8.00065 7.4987Z" />
        <path d="M12.0007 6.4987C12.0007 7.05098 11.5529 7.4987 11.0007 7.4987C10.4484 7.4987 10.0007 7.05098 10.0007 6.4987C10.0007 5.94641 10.4484 5.4987 11.0007 5.4987C11.5529 5.4987 12.0007 5.94641 12.0007 6.4987Z" />
        <path d="M5.00065 10.4987C5.55294 10.4987 6.00065 10.051 6.00065 9.4987C6.00065 8.94641 5.55294 8.4987 5.00065 8.4987C4.44837 8.4987 4.00065 8.94641 4.00065 9.4987C4.00065 10.051 4.44837 10.4987 5.00065 10.4987Z" />
        <path d="M9.00065 9.4987C9.00065 10.051 8.55294 10.4987 8.00065 10.4987C7.44837 10.4987 7.00065 10.051 7.00065 9.4987C7.00065 8.94641 7.44837 8.4987 8.00065 8.4987C8.55294 8.4987 9.00065 8.94641 9.00065 9.4987Z" />
        <path d="M11.0007 10.4987C11.5529 10.4987 12.0007 10.051 12.0007 9.4987C12.0007 8.94641 11.5529 8.4987 11.0007 8.4987C10.4484 8.4987 10.0007 8.94641 10.0007 9.4987C10.0007 10.051 10.4484 10.4987 11.0007 10.4987Z" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.00065 1.33203H6.33398V1.9987H9.66732V1.33203H11.0007V1.9987H14.6673V13.9987H1.33398V1.9987H5.00065V1.33203ZM5.00065 3.33203H2.66732V12.6654H13.334V3.33203H11.0007V3.9987H9.66732V3.33203H6.33398V3.9987H5.00065V3.33203Z"
        />
    </svg>
);
